import type { NeedsCategory } from './types'
import { needsCategoryLabels } from './types'

export interface NeedsCategoryCard {
  value: NeedsCategory
  label: string
  /** Kratko, jednostavno objašnjenje (Easy Read ton). */
  description: string
  emoji: string
}

/**
 * Sadržaj kartica za wizard "Tvoje potrebe".
 * Ton je jednostavan i bez stigme — opisuje šta korisniku olakšava korišćenje.
 */
export const NEEDS_CATEGORY_CARDS: NeedsCategoryCard[] = [
  {
    value: 'dyslexia',
    label: needsCategoryLabels.dyslexia,
    description: 'Lakše čitam uz poseban font i veće razmake.',
    emoji: '📖',
  },
  {
    value: 'low-vision',
    label: needsCategoryLabels['low-vision'],
    description: 'Slabije vidim — treba mi veći tekst i jak kontrast.',
    emoji: '🔍',
  },
  {
    value: 'blindness',
    label: needsCategoryLabels.blindness,
    description: 'Koristim čitač ekrana i slušam sadržaj.',
    emoji: '🦯',
  },
  {
    value: 'color-blindness',
    label: needsCategoryLabels['color-blindness'],
    description: 'Teže razlikujem neke boje.',
    emoji: '🎨',
  },
  {
    value: 'autism',
    label: needsCategoryLabels.autism,
    description: 'Prija mi miran ekran bez mnogo pokreta.',
    emoji: '🧩',
  },
  {
    value: 'adhd',
    label: needsCategoryLabels.adhd,
    description: 'Lakše se fokusiram bez ometanja.',
    emoji: '🎯',
  },
  {
    value: 'intellectual',
    label: needsCategoryLabels.intellectual,
    description: 'Pomažu mi jednostavan tekst i čitanje naglas.',
    emoji: '💡',
  },
  {
    value: 'deaf-hoh',
    label: needsCategoryLabels['deaf-hoh'],
    description: 'Trebaju mi titlovi i znakovni jezik.',
    emoji: '🤟',
  },
  {
    value: 'motor',
    label: needsCategoryLabels.motor,
    description: 'Koristim tastaturu — treba mi jasan fokus.',
    emoji: '⌨️',
  },
]
